import React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

export function Calendar({
  mode = "single",
  selected,
  onSelect,
  className,
  ...props
}) {
  return (
    <DayPicker
      mode={mode}
      selected={selected}
      onSelect={onSelect}
      className={`p-3 border border-gray-300 rounded-lg shadow-md ${className || ''}`}
      styles={{
        caption: { fontSize: '1.25rem', color: '#1F2937' },
        head: { backgroundColor: '#F3F4F6' },
        day: { color: '#374151' },
        selected: { backgroundColor: '#2563EB', color: '#FFFFFF' },
        today: { border: '1px solid #2563EB' },
      }}
      {...props}
    />
  );
}